import { render, staticRenderFns } from "./train.vue?vue&type=template&id=5ad8bf8c&scoped=true"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8bf8c",
  null
  
)

export default component.exports